<span mat-button mat-dialog-close class="right pointer"><i id="closeOverlay" class="far fa-times-circle"></i></span>
<h1 mat-dialog-title>Unprocessable Deliveries</h1>
<div mat-dialog-content>
    <p>
        <b>Please remove above deliveries first for further proceed.</b>
    </p>
    <h3>NOT DELIVERED DELIVERIES</h3>
    <ul>
        <li *ngFor="let delivery of notApplicableDeliveries">#{{ delivery.id }}</li>
    </ul>
    <h3>NOT MATCHING ALL CONDITIONS DELIVERIES</h3>
    <ul>
        <li *ngFor="let delivery of excludedDeliveries">#{{ delivery.id }}</li>
    </ul>
</div>
<div mat-dialog-actions></div>